/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Aggiungi"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Rimuovi tutto"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var itIT = Object.assign(TranslationProviderComponent, {
  translations
});

export { itIT as i };
//# sourceMappingURL=it-IT-B04xf_Ur.js.map
